export interface TeamMember {
  name: string;
  role: string;
  avatarUrl: string;
  bio: string;
}

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export const aboutInfo = {
  brandName: "草莓色研社",
  brandIntro: "草莓色研社成立于2022年，是国内首个专注于草莓主题视频色彩校正与拍摄技巧的专业内容平台。我们汇聚了一群热爱草莓、热爱影像创作的摄影师和调色师，致力于将专业的视频调色知识以通俗易懂的方式传递给每一位创作者。",
  mission: "让每一颗草莓在镜头前绽放最美的色彩，帮助每一位创作者拍出令人心动的草莓视频。",
  vision: "成为国内草莓视频创作领域的首选学习平台，推动食品视频行业色彩标准的建立与普及。",
  reputation: [
    "累计发布专业教程文章80+篇，覆盖草莓视频调色全链路知识",
    "全网粉丝超过50万，视频教程累计播放量超过2000万次",
    "与多家食品品牌和摄影器材厂商建立合作关系",
    "教程被多所高校影视专业列入推荐学习资源",
    "学员作品多次在国内外食品摄影大赛中获奖",
  ],
  team: [
    {
      name: "李明远",
      role: "创始人 & 首席调色师",
      avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20portrait%20in%20creative%20studio%20environment%2C%20warm%20lighting%2C%20friendly%20expression%2C%20modern%20casual%20attire%2C%20clean%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=team-member-1&orientation=squarish",
      bio: "拥有8年视频调色经验，曾参与多部美食纪录片的后期调色工作。达芬奇认证调色师，擅长食品类视频的色彩管理与风格化呈现。",
    },
    {
      name: "王思涵",
      role: "联合创始人 & 首席摄影师",
      avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20portrait%20with%20camera%20in%20hands%2C%20creative%20photography%20studio%2C%20warm%20natural%20lighting%2C%20confident%20expression%2C%20modern%20style%2C%20professional%20headshot&width=200&height=200&seq=team-member-2&orientation=squarish",
      bio: "资深食品摄影师，作品曾发表于《美食与美酒》《时尚芭莎》等杂志。专注于食品造型与光影设计，对草莓类水果的拍摄有一套独特的理解和方法。",
    },
    {
      name: "张雨桐",
      role: "内容主编",
      avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20portrait%20in%20modern%20office%20environment%2C%20warm%20natural%20lighting%2C%20intellectual%20look%2C%20elegant%20casual%20style%2C%20clean%20minimalist%20background%2C%20professional%20headshot&width=200&height=200&seq=team-member-3&orientation=squarish",
      bio: "前新媒体编辑，擅长将专业调色知识转化为通俗易懂的教程内容。主导编写了平台80%以上的教程文章，读者好评率超过98%。",
    },
  ],
  milestones: [
    { year: "2022年3月", title: "草莓色研社成立", description: "三位创始人在一次草莓园拍摄中相遇，决定共同创建一个专注于草莓视频调色的知识平台。" },
    { year: "2022年8月", title: "发布第一篇教程", description: "《草莓视频白平衡校正完全指南》发布，一周内获得超过10万次阅读，坚定了团队的信心。" },
    { year: "2023年1月", title: "视频教程系列上线", description: "推出「30天草莓调色训练营」视频课程，首期学员超过2000人。" },
    { year: "2023年6月", title: "全网粉丝突破20万", description: "通过高质量的内容输出，全平台累计粉丝数突破20万，成为草莓视频调色领域的头部账号。" },
    { year: "2024年3月", title: "与达芬奇官方合作", description: "获得Blackmagic Design官方认证，成为达芬奇调色软件的教育合作伙伴。" },
    { year: "2025年12月", title: "全网粉丝突破50万", description: "内容体系更加完善，累计帮助超过10万名创作者提升了草莓视频调色技能。" },
  ],
  contact: {
    email: "hello@strawberrycolor.cn",
    wechat: "StrawberryColor2022",
    weibo: "@草莓色研社",
    bilibili: "草莓色研社官方",
    address: "浙江省杭州市西湖区创意路88号草莓创意园A座302室",
    phone: "0571-8888-6666",
  },
};